const innkrevingSitePaths = {
  shortUrl: "/innkreving",
  page: "/innkreving/:path/:id?",
  detalj: "/innkreving/ileggelser/:id",
  ileggelser: {
    shortUrl: "/innkreving/ileggelser",
    page: "/innkreving/ileggelser/:id",
    venter: {
      shortUrl: "/innkreving/ileggelser/venter",
      detalj: {
        route: "/innkreving/ileggelser/venter/:id",
        getUrl: (ileggelseId) => `/innkreving/ileggelser/venter/${ileggelseId}`,
        svarUtHistorikk:
          "/innkreving/ileggelser/venter/:id/svar-ut/:svarUtId/historikk",
        rediger: "/innkreving/ileggelser/venter/:id/bilder/:bildeId/rediger",
        bilde: "/innkreving/ileggelser/venter/:id/bilder/:bildeId",
      },
    },
    stoppet: {
      shortUrl: "/innkreving/ileggelser/stoppet",
      detalj: {
        route: "/innkreving/ileggelser/stoppet/:id",
        getUrl: (ileggelseId) =>
          `/innkreving/ileggelser/stoppet/${ileggelseId}`,
        svarUtHistorikk:
          "/innkreving/ileggelser/stoppet/:id/svar-ut/:svarUtId/historikk",
        rediger: "/innkreving/ileggelser/stoppet/:id/bilder/:bildeId/rediger",
        bilde: "/innkreving/ileggelser/stoppet/:id/bilder/:bildeId",
      },
    },
    klar: {
      shortUrl: "/innkreving/ileggelser/klar",
      detalj: {
        route: "/innkreving/ileggelser/klar/:id",
        getUrl: (ileggelseId) => `/innkreving/ileggelser/klar/${ileggelseId}`,
        svarUtHistorikk:
          "/innkreving/ileggelser/klar/:id/svar-ut/:svarUtId/historikk",
        rediger: "/innkreving/ileggelser/klar/:id/bilder/:bildeId/rediger",
        bilde: "/innkreving/ileggelser/klar/:id/bilder/:bildeId",
      },
    },
    behandlesInnkreving: {
      shortUrl: "/innkreving/ileggelser/behandles-innkreving",
      detalj: {
        route: "/innkreving/ileggelser/behandles-innkreving/:id",
        getUrl: (ileggelseId) =>
          `/innkreving/ileggelser/behandles-innkreving/${ileggelseId}`,
        svarUtHistorikk:
          "/innkreving/ileggelser/behandles-innkreving/:id/svar-ut/:svarUtId/historikk",
        rediger:
          "/innkreving/ileggelser/behandles-innkreving/:id/bilder/:bildeId/rediger",
        bilde:
          "/innkreving/ileggelser/behandles-innkreving/:id/bilder/:bildeId",
      },
    },
    feilet: {
      shortUrl: "/innkreving/ileggelser/feilet",
      detalj: {
        route: "/innkreving/ileggelser/feilet/:id",
        getUrl: (ileggelseId) => `/innkreving/ileggelser/feilet/${ileggelseId}`,
        svarUtHistorikk:
          "/innkreving/ileggelser/feilet/:id/svar-ut/:svarUtId/historikk",
        rediger: "/innkreving/ileggelser/feilet/:id/bilder/:bildeId/rediger",
        bilde: "/innkreving/ileggelser/feilet/:id/bilder/:bildeId",
      },
    },
    vellykket: {
      shortUrl: "/innkreving/ileggelser/vellykket",
      detalj: {
        route: "/innkreving/ileggelser/vellykket/:id",
        getUrl: (ileggelseId) =>
          `/innkreving/ileggelser/vellykket/${ileggelseId}`,
        svarUtHistorikk:
          "/innkreving/ileggelser/vellykket/:id/svar-ut/:svarUtId/historikk",
        rediger: "/innkreving/ileggelser/vellykket/:id/bilder/:bildeId/rediger",
        bilde: "/innkreving/ileggelser/vellykket/:id/bilder/:bildeId",
      },
    },
    default: "/innkreving/ileggelser/stoppet",
  },
  miljogebyr: {
    shortUrl: "/innkreving/miljogebyr/",
    page: "/innkreving/miljogebyr/:id",
    venter: {
      shortUrl: "/innkreving/miljogebyr/venter",
      detalj: {
        route: "/innkreving/miljogebyr/venter/:id",
        getUrl: (ileggelseId) => `/innkreving/miljogebyr/venter/${ileggelseId}`,
        svarUtHistorikk:
          "/innkreving/miljogebyr/venter/:id/svar-ut/:svarUtId/historikk",
        rediger: "/innkreving/miljogebyr/venter/:id/bilder/:bildeId/rediger",
        bilde: "/innkreving/miljogebyr/venter/:id/bilder/:bildeId",
      },
    },
    stoppet: {
      shortUrl: "/innkreving/miljogebyr/stoppet",
      detalj: {
        route: "/innkreving/miljogebyr/stoppet/:id",
        getUrl: (ileggelseId) =>
          `/innkreving/miljogebyr/stoppet/${ileggelseId}`,
        svarUtHistorikk:
          "/innkreving/miljogebyr/stoppet/:id/svar-ut/:svarUtId/historikk",
        rediger: "/innkreving/miljogebyr/stoppet/:id/bilder/:bildeId/rediger",
        bilde: "/innkreving/miljogebyr/stoppet/:id/bilder/:bildeId",
      },
    },
    klar: {
      shortUrl: "/innkreving/miljogebyr/klar",
      detalj: {
        route: "/innkreving/miljogebyr/klar/:id",
        getUrl: (ileggelseId) => `/innkreving/miljogebyr/klar/${ileggelseId}`,
        svarUtHistorikk:
          "/innkreving/miljogebyr/klar/:id/svar-ut/:svarUtId/historikk",
        rediger: "/innkreving/miljogebyr/klar/:id/bilder/:bildeId/rediger",
        bilde: "/innkreving/miljogebyr/klar/:id/bilder/:bildeId",
      },
    },
    behandlesInnkreving: {
      shortUrl: "/innkreving/miljogebyr/behandles-innkreving",
      detalj: {
        route: "/innkreving/miljogebyr/behandles-innkreving/:id",
        getUrl: (ileggelseId) =>
          `/innkreving/miljogebyr/behandles-innkreving/${ileggelseId}`,
        svarUtHistorikk:
          "/innkreving/miljogebyr/behandles-innkreving/:id/svar-ut/:svarUtId/historikk",
        rediger:
          "/innkreving/miljogebyr/behandles-innkreving/:id/bilder/:bildeId/rediger",
        bilde:
          "/innkreving/miljogebyr/behandles-innkreving/:id/bilder/:bildeId",
      },
    },
    feilet: {
      shortUrl: "/innkreving/miljogebyr/feilet",
      detalj: {
        route: "/innkreving/miljogebyr/feilet/:id",
        getUrl: (ileggelseId) => `/innkreving/miljogebyr/feilet/${ileggelseId}`,
        svarUtHistorikk:
          "/innkreving/miljogebyr/feilet/:id/svar-ut/:svarUtId/historikk",
        rediger: "/innkreving/miljogebyr/feilet/:id/bilder/:bildeId/rediger",
        bilde: "/innkreving/miljogebyr/feilet/:id/bilder/:bildeId",
      },
    },
    vellykket: {
      shortUrl: "/innkreving/miljogebyr/vellykket",
      detalj: {
        route: "/innkreving/miljogebyr/vellykket/:id",
        getUrl: (ileggelseId) =>
          `/innkreving/miljogebyr/vellykket/${ileggelseId}`,
        svarUtHistorikk:
          "/innkreving/miljogebyr/vellykket/:id/svar-ut/:svarUtId/historikk",
        rediger: "/innkreving/miljogebyr/vellykket/:id/bilder/:bildeId/rediger",
        bilde: "/innkreving/miljogebyr/vellykket/:id/bilder/:bildeId",
      },
    },
    default: "/innkreving/miljogebyr/stoppet",
  },
  default: "/innkreving/ileggelser/stoppet",
};

export default innkrevingSitePaths;
